// Filestack rejects an upload above this cap. The per-cell cap is blackbox's row
// guard: a row with a larger cell is skipped and reported, not fatal to the import.
export const MAX_FILE_SIZE_MB = 50;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
export const MAX_CELL_CHARACTERS = 32767;
